import axios from 'axios';
import _ from 'lodash';
import { push } from 'connected-react-router';
import { NETWORK, FORM_ID} from '../../../../../framework/App/AppConstants';
import setUrl from '../../../../../framework/App/SetUrl';
import { PAGE_NAME, SUBMIT_API, APPLICATION_STATUS} from '../../../../config/DEConstants';
import { setServerData } from '../../../../../framework/store/ServerData/ServerDataActions';
import { SubmissionError, change, untouch } from 'redux-form';
import { scrollToTop } from '../../../../../framework/App/SkeletonPage/SkeletonPageActions';
import { processSubmissionErrors } from '../../../../../shared-components/FormElement/FormElementUtils';
import { spinnerClose } from '../../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { DOB_INFO_SECTION, BANK_INFO_SECTION } from './ApplyPageFormConstants';
import { trackTransition } from '../../../../../framework/store/FPTI/FPTIActions';
import { buildCapeTxnRunner } from '../../../../../framework/App/CapeTransaction';
import {safeStringify} from '../../../../../../../server/src/CAP/GPL/util/stringUtil';
const runDeApplyCapeTxn = buildCapeTxnRunner('de_apply');

export const handleRedirect = response => {
    if (response && _.get(response, 'data.redirect')) {
        setUrl(window, response.data.redirect);
        return true;
    }
    return false;
};

export const showSoftDecline = () => dispatch => {
    //for clearing out the DOB field on soft-decline
    dispatch(change(FORM_ID, `${DOB_INFO_SECTION}.dobDay`, ''));
    dispatch(untouch(FORM_ID, `${DOB_INFO_SECTION}.dobDay`));
    dispatch(change(FORM_ID, `${DOB_INFO_SECTION}.dobMonth`, ''));
    dispatch(untouch(FORM_ID, `${DOB_INFO_SECTION}.dobMonth`));
    dispatch(change(FORM_ID, `${DOB_INFO_SECTION}.dobYear`, ''));
    dispatch(untouch(FORM_ID, `${DOB_INFO_SECTION}.dobYear`));
    dispatch(change(FORM_ID, `${BANK_INFO_SECTION}.iban`, ''));
    dispatch(untouch(FORM_ID, `${BANK_INFO_SECTION}.iban`));
    dispatch(scrollToTop());
};

export const submitApplicationApi = (data, localePrefix) => (dispatch, getState) => {
    return runDeApplyCapeTxn(() => {
        const state = getState();
        const { serverData = {} } = state;
        const { _csrf = '' } = serverData;

        return axios
            .request({
                url: SUBMIT_API,
                method: 'post',
                headers: {
                    ...NETWORK.REQUEST.XHR.HEADER,
                    'X-CSRF-Token': _csrf
                },
                data
            })
            .then(response => {
                if (!_.isEmpty(_.get(response, 'data.validation.errors'))) {
                    dispatch(scrollToTop());
                    dispatch(spinnerClose());
                    capeLog && capeLog(`submitApplicationApi:de:response: server validation error: ${safeStringify(response.data.validation.errors)}`);
                    return Promise.reject(new SubmissionError(processSubmissionErrors(response.data.validation.errors.fieldError, localePrefix), state));
                } else {
                    if (handleRedirect(response)) {
                        return;
                    }
                    dispatch(spinnerClose());
                    dispatch(setServerData({
                        decisionModel: response.data,
                        invalidAddressMsg: _.get(response, 'data.showInvalidAddress'),
                        showValidationSoftDecline: _.get(response, 'data.showValidationSoftDecline')
                    }));
                    const appStatus = _.get(response, 'data.applicationStatus');
                    capeLog && capeLog(`submitApplicationApi:de:response: applicationStatus: ${appStatus}`);

                    if (appStatus === APPLICATION_STATUS.PENDING) {
                        dispatch(push(PAGE_NAME.CONTRACT_PAGE));
                    } else if (appStatus === APPLICATION_STATUS.VIEW_SEPA) {
                        // SepaModel now is decisionModel: agreementDateFormat, bank, creditor, owner
                        dispatch(push(PAGE_NAME.SEPA_PAGE));
                    } else if (appStatus === APPLICATION_STATUS.SOFT_DECLINE) {
                        dispatch(showSoftDecline());
                    } else if (appStatus === APPLICATION_STATUS.ANS_SOFT_DECLINE) {
                        const extra = {};
                        extra.ppc_status = appStatus;
                        dispatch(trackTransition('pp_credit_applypage', 'prepare_pp_credit_applypage', extra));
                        dispatch(showSoftDecline());
                    } else {
                        dispatch(push(PAGE_NAME.DECISION_PAGE));
                    }
                }
            })
            .catch(error => {
                if (error instanceof SubmissionError) {
                    return Promise.reject(error);
                }
                capeLog && capeLog('response:error, DE_Guest_ApplyPageFormActions,' + (error && error.message));

                if (handleRedirect(error && error.response)) {
                    return;
                }
                if (_.get(error, 'response.data.err', false)) {
                    dispatch(setServerData({ errorModel: _.get(error, 'response.data', {}) }));
                    dispatch(push(PAGE_NAME.ERROR_PAGE));
                    dispatch(spinnerClose());
                } else {
                    // should never be here
                    capeLog && capeLog('response:error: unexpected error response for Application Pahe submit');
                    setUrl(window, PAGE_NAME.ERROR_PAGE);
                }
            });
    });
};
